import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { HomePage } from '../../../../translations/trans';
import { addReportManyLesson } from '../../../../utils/lessons';
import { ErrorMsg } from '../../../../utils/Toast';
import { getLessonsByClassId } from '../../../../utils/class';

const SendLessonsReportToClass = ({ classId, type }) => {
    const [show, setShow] = useState(false);
    const [selectedLessons, setSelectedLessons] = useState([]);
    const [loading, setLoading] = useState(false);
    const [lessons, setLessons] = useState([]);

    const { lang, dir } = useSelector(({ language }) => ({
        lang: language.lang,
        dir: language.dir,
    }));

    const loggedUser = useSelector((state) => state.loggedUser);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
        const fetchLessons = async () => {
            try {
                const res = await getLessonsByClassId(classId, loggedUser?.user?._id);
                setLessons(res?.data?.lessons || []);
            } catch (err) {
                ErrorMsg(err?.message);
                console.error(err);
            }
        };
        fetchLessons();
    }, [classId, loggedUser]);

    const handleAddReport = async () => {
        try {
            setLoading(true);
            await addReportManyLesson(
                {
                    about: type,
                    lessonIds: selectedLessons,
                },
                classId,
                loggedUser?.user?._id
            );
            handleClose();
        } catch (e) {
            console.error(e);
            ErrorMsg(e?.response?.data?.message || e?.response?.data);
        } finally {
            setLoading(false);
        }
    };

    const handleLessonSelect = (lessonId) => {
        if (lessonId && !selectedLessons.includes(lessonId)) {
            setSelectedLessons([...selectedLessons, lessonId]);
        }
    };

    const handleLessonRemove = (lessonId) => {
        setSelectedLessons(selectedLessons.filter((id) => id !== lessonId));
    };

    return (
        <div className="text-center">
            {/* Styled button using Bootstrap */}
            <button className="btn btn-primary px-4 py-2" onClick={handleShow}>
                {HomePage.sendReports[lang]} ({type})
            </button>

            <Modal show={show} onHide={handleClose} centered dir={dir} className="font">
                <Modal.Header closeButton>
                    <Modal.Title>{HomePage.sendReports[lang]} ({type})</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="form-group">
                        <label>{HomePage.lessonName[lang]}</label>
                        <select
                            className="form-control"
                            onChange={(e) => handleLessonSelect(e.target.value)}
                            defaultValue=""
                        >
                            <option hidden>Select Lesson</option>
                            {lessons.map((lesson) => (
                                <option key={lesson?._id} value={lesson?._id}>
                                    {lesson?.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    {selectedLessons.length > 0 && (
                        <div className="mt-3">
                            <h6>Selected Lessons:</h6>
                            <ul className="list-group">
                                {lessons
                                    .filter((l) => selectedLessons.includes(l._id))
                                    .map((l) => (
                                        <li
                                            key={l._id}
                                            className="list-group-item d-flex justify-content-between align-items-center"
                                        >
                                            {l.name}
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm"
                                                onClick={() => handleLessonRemove(l._id)}
                                            >
                                                ×
                                            </button>
                                        </li>
                                    ))}
                            </ul>
                        </div>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        {HomePage.cancel[lang] || "Cancel"}
                    </Button>
                    <Button
                        variant="success"
                        onClick={handleAddReport}
                        disabled={loading || selectedLessons.length === 0}
                    >
                        {loading ? "Loading..." : HomePage.sendMsg[lang] || "Send"}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default SendLessonsReportToClass;
